import {
    requestMethodTypes,
    requestHeaderNames,
    requestHeaderValue,
} from '../Constants/api.constants';

const resumePointsRequest = (
    requestData = {}
) => {
    const {
        AUTHORIZATION,
        CONTENT_TYPE,
    } = requestHeaderNames;
    const {
        CONTENT_TYPE_JSON,
        BEARER,
    } = requestHeaderValue;

    const method = requestMethodTypes.POST;
    const headers = {
        [CONTENT_TYPE]: CONTENT_TYPE_JSON,
        [AUTHORIZATION]: `${BEARER} ${requestData.authToken}`,
    };

    const data = {
        assetId: requestData.assetId,
        articleTypeId: requestData.articleTypeId,
        contentLength: requestData.contentLength,
        position: requestData.position,
        videoType: requestData.videoType,
    };

    if (requestData.eventId) {
        data.eventId = requestData.eventId;
    }

    const request = {
        method,
        headers,
        data,
    };

    return request;
};

export default resumePointsRequest;
